import { styled } from '@nykaa/ui-components';

export const CouponTitle = styled.div`
  width: 50%;
  height: 24px;
  ${({ theme }) => `margin: ${theme.spacing.spacing160} 0 ${theme.spacing.spacing40} 0;
  background-color: ${theme.colors.surface20}
  `};
`;

export const CouponContainer = styled.div`
  width: 100%;
  ${({ theme }) => `margin: ${theme.spacing.spacing40} 0 ${theme.spacing.spacing60} 0;
  background-color: ${theme.colors.surface20}`};
  height: 148px;
  margin-bottom: 2rem;
`;

export const OfferTitle = styled.div`
  width: 50%;
  height: 24px;
  background-color: ${({ theme }) => theme.colors.surface20};
`;

export const OfferContainer = styled.div`
  width: 100%;
  ${({ theme }) => `margin: ${theme.spacing.spacing40} 0 ${theme.spacing.spacing60} 0`};
  height: 96px;
  background-color: ${({ theme }) => theme.colors.surface20};
`;
